import * as Api from '@ViewModels';
import { observer } from 'mobx-react';
import { SizeConstraint } from '../../../../models';
import { invalidateCompanyTimeline } from '../../../../queries';
import { Timeline } from './Timeline';
import { useCompanyTimeline } from './hooks/useTimeline';

interface IProps {
	className?: string;
	companyId: string;
	onDeleteRichContent: (richContent: Api.RichContentViewModel) => Promise<Api.IRichContent>;
	readonly?: boolean;
	renderAction?(evt: Api.TimelineEventViewModel): JSX.Element;
	renderActionFor?: Api.TimelineEventTypes[];
	renderContent?(evt: Api.TimelineEventViewModel): JSX.Element;
	renderContentFor?: Api.TimelineEventTypes[];
	placeholderText?: string;
	sizeConstraint?: SizeConstraint;
	eventTypes: Api.TimelineEventTypes[];
}

function _CompanyTimeline({
	companyId,
	eventTypes,
	className,
	sizeConstraint,
	placeholderText,
	renderAction,
	renderActionFor,
	readonly,
	renderContentFor,
	renderContent,
	onDeleteRichContent,
}: IProps) {
	const timelineProps = useCompanyTimeline({
		companyId,
		eventTypes,
	});
	return (
		<Timeline
			className={className}
			sizeConstraint={sizeConstraint}
			placeholderText={placeholderText}
			renderAction={renderAction}
			renderActionFor={renderActionFor}
			readonly={readonly}
			renderContentFor={renderContentFor}
			renderContent={renderContent}
			onTimelineDataUpdated={() => invalidateCompanyTimeline({ companyId })}
			onDeleteRichContent={onDeleteRichContent}
			{...timelineProps}
		/>
	);
}

export const CompanyTimeline = observer(_CompanyTimeline);
